module.exports = __webpack_public_path__ + "static/media/project24.4c331545.jpg";